import { Layout } from "../../nq-component";
import React from "react";

function MenuX() {
  const { collapsed, setCollapse } = React.useContext(Layout.Context);

  function onClick() {
    setCollapse(!collapsed);
  }
  return (
    <button className="btn btn-link p-0" onClick={onClick}>
      <i className="bi bi-x-lg fw-bold fs-5"></i>
    </button>
  );
}

export default MenuX;
